import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExgTextareaInputComponent} from '../../misc/exg-textarea-input/exg-textarea-input.component';
import {CommentaryBoxComponent} from './commentary-box/commentary-box.component';
import {ExcSecurityService} from 'exc-security-v2';
import {AppComponent} from '../../app.component';

@Component({
  selector: 'app-commentary-modal',
  templateUrl: './commentary-modal.component.html',
})
export class CommentaryModalComponent extends ExcTranslation implements OnInit {
  @ViewChild('VCValueText', {read: ExgTextareaInputComponent}) VCValueText!: ExgTextareaInputComponent;
  @ViewChild('VCContentBox', {read: CommentaryBoxComponent}) VCContentBox!: CommentaryBoxComponent;

  @Input() data: any;
  set newEntryComment(value: {commText: string, commTyp: number }) {
    this._newEntryComment = value;
  }
  get newEntryComment(): { commText: string; commTyp: number } {
    return this._newEntryComment;
  }
  set newComment(value: string) {
    this._newComment = value;
  }
  get newComment(): string {
    return this.VCValueText ? this.VCValueText.value : this._newComment;
  }

  _newComment!: string;
  _newEntryComment!: { commText: string; commTyp: number; };
  constructor(
    public appData: AppComponent,
    private ModalService: ExgModalService,
    public excSecurity: ExcSecurityService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.reinitialize(true);
  }

  reinitialize(readList: boolean): void {
    this.setDefault();
    if (readList) {
      this.data.checkview.loadCommentaryList();
    }
  }

  setDefault(): void {
    this.newComment = '';
    this.newEntryComment = { commText: '', commTyp: 1 };
    if (this.VCValueText) {
      this.VCValueText.value = '';
    }
  }

  send(): void {
    this.newEntryComment = { commText: this.newComment, commTyp: 1 };
    this.data.checkview.commentaryCreate(this.newEntryComment);
    this.close();
  }

  close(): void {
    this.ModalService.close();
  }
}
